import { render, staticRenderFns } from "./ScaniaNextGenBar.vue?vue&type=template&id=e678c88e&"
import script from "./ScaniaNextGenBar.vue?vue&type=script&lang=js&"
export * from "./ScaniaNextGenBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports